import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FiArrowLeft } from 'react-icons/fi';

export default function TermsOfUse() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const goBack = () => {
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-brand-black text-white/80 font-inter pt-32 pb-20 px-6">
      <div className="max-w-4xl mx-auto">
        <button onClick={goBack} className="flex items-center gap-2 text-brand-gold hover:text-brand-orange transition-colors mb-8 text-sm uppercase tracking-widest font-cinzel">
          <FiArrowLeft /> Back
        </button>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <h1 className="text-3xl md:text-5xl font-cinzel text-brand-gold mb-8">Terms of Use</h1>
          <div className="space-y-6 text-sm md:text-base leading-relaxed text-white/60">
            <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>
            <h2 className="text-xl text-white mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>By accessing and using the Magic Moon Studios website, you accept and agree to be bound by the terms and provision of this agreement. In addition, when using these particular services, you shall be subject to any posted guidelines or rules applicable to such services.</p>
            
            <h2 className="text-xl text-white mt-8 mb-4">2. Intellectual Property</h2>
            <p>The Site and its original content, features, and functionality are owned by Magic Moon Studios and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.</p>
            
            <h2 className="text-xl text-white mt-8 mb-4">3. User Conduct</h2>
            <p>You agree not to use the website for any unlawful purpose or any purpose prohibited under this clause. You agree not to use the website in any way that could damage the website, the services or the general business of Magic Moon Studios.</p>

            <h2 className="text-xl text-white mt-8 mb-4">4. Limitation of Liability</h2>
            <p>In no event shall Magic Moon Studios, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for damages, direct or consequential, resulting from your use of the site, and you agree to defend, indemnify and hold us harmless from any claims, losses, liability costs and expenses.</p>

            <h2 className="text-xl text-white mt-8 mb-4">5. Changes to Terms</h2>
            <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes a material change will be determined at our sole discretion.</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
